import { render, staticRenderFns } from "./GeneralHealth.vue?vue&type=template&id=ff4aba94&"
import script from "./GeneralHealth.vue?vue&type=script&lang=js&"
export * from "./GeneralHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports